
<template>

  <div id="app">

    <NavBar />
    <router-view />
  </div>

</template>

<script>

  import NavBar from '@/components/NavBar'

  export default {
    name: 'App',
    components: {
      NavBar
    }
  }

</script>

<style>

  body {
    font-family: 'Libre Franklin', sans-serif;
    background: #fff;
    color: #33322d;
    margin: 120px 20px 100px 20px;
  }
  @media (max-width: 1024px) {
    body {
      margin: 80px 20px 100px 20px;
    }
  }

  h1,
  h2,
  h3,
  h4 {
    font-weight: 100;
  }

  strong{
    font-weight:800;
  }
  a{
    text-decoration: underline;
  }


  .underline-orange{
    text-decoration: underline;
    text-decoration-color: #dd694a;
  }

  .underline-teal{
    text-decoration: underline;
    text-decoration-color: #197278;
  }

  .underline-purple{
    text-decoration: underline;
    text-decoration-color: #864789;
  }


  .underline-orange:hover,.underline-purple:hover,.underline-teal:hover{
    text-decoration: underline;
    text-decoration-color: #33322d;
  }

  .text-snippet {
    font-size: 12px;
  }

  input,textarea {
    padding: 1rem;
    border: 1px solid gray;
  }


</style>



// WEBPACK FOOTER //
// src/App.vue